import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchform"]

  reset(event) {
    event.preventDefault()

    const form = this.searchformTarget

    // Reset all form fields
    form.reset()

    // Reset Choices.js selects
    form.querySelectorAll('.select-choices').forEach(select => {
      if (select.choices) {
        select.choices.removeActiveItems()
      }
    })

    // Submit form to refresh results
    form.requestSubmit()
  }
}
